module.exports = __webpack_public_path__ + "static/media/antimatter_logo_nft.c3649459.svg";